class WishlistTrigger extends HTMLElement {
  static get observedAttributes () {
    return ['data-initialized']
  }

  connectedCallback () {
    this.swatReady = false
    this.trigger = this.querySelector('[data-wishlist-trigger-button]')

    if (!this.trigger) return

    this.setupListeners()
    this.checkState()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'data-initialized' && newValue === 'true') {
      this.checkState()
    }
  }

  setupListeners () {
    window.addEventListener(window.theme.wishlist.eventBus.wishlist_added_product, (event) => {
      if (event.detail.productId !== Number(this.trigger.dataset.productId)) return

      this.checkState('add')
    })

    window.addEventListener(window.theme.wishlist.eventBus.wishlist_removed_product, (event) => {
      if (event.detail.productId !== Number(this.trigger.dataset.productId)) return

      this.checkState('remove')
    })

    this.trigger.addEventListener('click', this.handleTrigger.bind(this))
  }

  async checkState (action) {
    if (!this.swatReady) {
      await this.checkSwatReady()
    }

    this.setAttribute('aria-hidden', 'false')

    if (action) {
      this.trigger.setAttribute('data-wishlist-added', action === 'add')
    } else {
      const wishlists = await this.fetchWishlists()
      const isRelatedProductInWishlist = wishlists.some(wishlist => wishlist.listcontents.some(product => product.empi === Number(this.trigger.dataset.productId)))

      this.trigger.setAttribute('data-wishlist-added', isRelatedProductInWishlist)
    }
  }

  handleTrigger () {
    const productId = this.trigger.dataset.productId
    const variantId = this.trigger.dataset.variantId
    const productUrl = this.trigger.dataset.productUrl
    const productTitle = this.trigger.dataset.productTitle
    const productPrice = this.trigger.dataset.productPrice

    const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_intent, {
      detail: {
        productId,
        variantId,
        productUrl,
        productTitle,
        productPrice,
      },
    })

    window.dispatchEvent(event)
  }

  fetchWishlists () {
    return new Promise((resolve) => {
      const onSuccess = function (wishlists) {
        // console.info('fetchWishlists() - Success', wishlists)

        resolve(wishlists)
      }
      const onError = function (error) {
        console.error('fetchWishlists() - Error', error)
      }

      window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError,
      })
    })
  }

  checkSwatReady () {
    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        if (!window._swat) return

        this.swatReady = true

        clearInterval(intervalId)

        resolve(true)
      }, 200)
    })
  }
}

customElements.define('wishlist-trigger', WishlistTrigger)
